<template>
    <div class="mx-auto w-full max-w-[1168px] pb-40 px-8 pt-6">
        <template v-if="state==='loaded'">
            <ui-header :title="`Site Instruction ${siteInstruction.referenceNumber}`"
                       :subtitle="'ID #'+this.siteInstruction.id">
                <template #actions>
                    <ui-dropdown placement="bottom-end" menu-class="p-3 w-72">
                        <template #default="{ toggle }">
                            <ui-button-new @click="toggle" primary>
                                Actions
                                <i class="flex-shrink-0 ml-2 fa fa-chevron-down"></i>
                            </ui-button-new>
                        </template>

                        <template #menu="{ close }">
                            <ui-dropdown-item @click.prevent="openDeleteModal();" danger icon="fa fa-trash">Delete</ui-dropdown-item>
                        </template>
                    </ui-dropdown>
                </template>
            </ui-header>
            <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mt-6">
                <div>
                    <ui-date-picker label="Date Issued" name="dateTime" v-model="siteInstruction.dateIssued"
                                    class="xl:col-span-6"
                                    placeholder="What is the date of issue?"
                                    :error="dateTimeError"
                                    :with-time="false"
                                    @change="save"
                                    @input="dateTimeError='';"></ui-date-picker>
                </div>
                <div>
                    <label class="block text-sm font-medium text-gray-700">Issued by</label>
                    <input class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 text-sm"
                           v-model="siteInstruction.issuedBy">
                </div>
                <div>
                    <ui-select label="Status"
                               @input="save"
                               :options="[{'value':'Pending','label':'Pending'},{'value':'Approved','label':'Approved'},{'value':'Rejected','label':'Rejected'}]"
                               v-model="siteInstruction.status"></ui-select>
                </div>
            </div>
            <div class="w-full mb-2 flex">
                <div class="flex-grow"></div>
                <div class="flex-shrink mb-1">
                    <ui-button-new small
                                   class="items-baseline"
                                   icon="fas fa-upload"
                                   @click="showFS">Site Instruction Files
                    </ui-button-new>
                </div>
            </div>
            <div>
                <ui-textarea autoresize label="Instruction Description" name="s" v-model="siteInstruction.description"
                             placeholder="House keeping for this progress report..."
                             @input="save"
                             class="xl:col-span-12"></ui-textarea>

            </div>
        </template>
    </div>
</template>

<script>
import UiContainer from "../../ui/UiContainer.vue";
import UiDatePicker from "../../ui/UiDatePicker.vue";
import UiButtonNew from "../../ui/UiButtonNew.vue";
import UiDataGridItem from "../../ui/UiDataGridItem.vue";
import UiHeader from "../../ui/UiHeader.vue";
import UiInput from "../../ui/UiInput.vue";
import UiToggle from "../../ui/UiToggle.vue";
import moment from "moment";
import {debounce} from "lodash";
import {SiteInstruction} from "@models";
import UiSelect from "../../ui/UiSelect.vue";

export default {
    components: {
        UiSelect,
        UiToggle, UiInput, UiHeader, UiDataGridItem, UiDatePicker, UiButtonNew, UiContainer
    },
    props: {
        item: Object,
        packageReference: null,
        fsModal: Object,
        removeItem: Function,
    },
    data() {
        return {
            siteInstruction: {},
            busy: false,
            dateTimeError: '',
            moment,
            state: 'loading',
            debouncedUpdate: debounce(this.update, 300),
        }
    },
    computed: {},
    methods: {
        async save() {
            this.dateTimeError = '';
            if (!this.siteInstruction.dateIssued) {
                this.dateTimeError = 'Please select a date of issue for this Site Instruction'
            } else {
                this.siteInstruction.formatted_date = moment(this.siteInstruction.dateIssued).format('DD/MM/YYYY');
                Object.assign(this.item, this.siteInstruction);
                this.debouncedUpdate();
            }
        },
        async update() {
            this.busy = true;
            this.siteInstruction.dateIssued = moment(this.siteInstruction.dateIssued).format("YYYY-MM-DD");
            await this.siteInstruction.update();
            this.busy = false;
        },
        showFS() {
            this.fsModal.openModal(this.siteInstruction.filesystemId);
        },
        minDate() {
            return null;
        },
        openDeleteModal() {
            const title = 'Are you sure you want to remove Site Instruction ' + this.item.referenceNumber + '?'
            const description = 'You are removing Site Instruction #' + this.item.id + '. Are you sure you want to do this?'
            eventBus.$emit('delete-modal-open', title, description, async () => {
                await this.siteInstruction.delete()
                this.removeItem(this.item)
            });
        },
    },
    async mounted() {
        this.siteInstruction = await SiteInstruction.find(this.packageReference, this.item.id);
        this.state = 'loaded'
    },
}
</script>
